import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { batchedSubscribe } from 'redux-batched-subscribe';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';

import root from '../reducers/root';
import sagas from './sagas';

const initialState = {
  thanksShowed: false,
  selectedDesignId: null,
  clientInfo: {},
  sharedDesigns: {
    isLoading: false,
    isLoadFailed: false,
    hasMore: false,
    categoryItems: {}
  },
  designsCategories: {
    items: [],
    children: [],
    isLoadFailed: false,
    isLoading: false
  }
};

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(createLogger());
}

const store = createStore(
  root,
  initialState,
  compose(
    applyMiddleware(...middlewares),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
    batchedSubscribe(batchedUpdates)
  )
);

sagaMiddleware.run(sagas);

export default () => store;



// WEBPACK FOOTER //
// ./src/store/createStore.js